import Marker from '../Marker';
import subpixel from '../util/canvasSubpixelOffset';
import canvasEnums from '../enums/canvas';
import translate from '../util/translate';

/** Band marker */
class BandMarker extends Marker {
	constructor(params, panel = null) {
		super(params, panel);
	}

	getDefaultParams() {
		return {
			labelText: 'Band',
			style: this.panel.core.getStyle('marker.band'),
			valHigh: 100,
			valLow: 0
		};
	}

	// Use the isUpperBand input if you want to draw only a single line for the band, leave empty for both horizontal edges of the rectangle
	render(panel, style = null, isUpperBand = undefined) {
		const ctx = panel.rootContext;
		const yScale = panel.yAxis.primaryScale;
		// Use default styles if none passed in
		if (!style) style = this.params.style;
		const panelLeft = panel.size.padding.left;
		const panelWidth = panel.size.width;
		const panelHeight = panel.size.height;
		const yHigh = yScale(this.params.valHigh);
		const yLow = yScale(this.params.valLow);
		const yMin = Math.floor(Math.max(0, Math.min(yHigh, yLow)));
		const yMax = Math.ceil(Math.min(panelHeight, Math.max(yHigh, yLow)));

		ctx.fillStyle = style.background.color;
		ctx.lineWidth = style.width;
		ctx.strokeStyle = style.color;
		ctx.beginPath();

		// fill rect
		subpixel.rect(ctx, panelLeft, yMin, panelWidth, yMax - yMin);
		ctx.fill();

		// Draw the rectangle's edges
		ctx.beginPath();

		ctx.save();
		if (style.lineDash) ctx.setLineDash(style.lineDash.split(/\s*,\s*/));
		if (isUpperBand === undefined) {
			subpixel.moveTo(ctx, panelLeft, yMin);
			subpixel.lineTo(ctx, panelLeft + panelWidth, yMin);

			subpixel.moveTo(ctx, panelLeft, yMax);
			subpixel.lineTo(ctx, panelLeft + panelWidth, yMax);
		} else if (isUpperBand) {
			// draws the lower edge of the band's rectangle
			subpixel.moveTo(ctx, panelLeft, yMax);
			subpixel.lineTo(ctx, panelLeft + panelWidth, yMax);
		} else {
			// draws the upper edge of the band's rectangle
			subpixel.moveTo(ctx, panelLeft, yMin);
			subpixel.lineTo(ctx, panelLeft + panelWidth, yMin);
		}
		ctx.stroke();
		ctx.restore();

		// Only render labels if there's enough room
		if (yMax - yMin > 18) {
			// label text
			ctx.textBaseline = 'middle';
			ctx.font = panel.getFontStyle(
				style.label.font.weight,
				style.label.font.size,
				style.label.font.family
			);

			// Calculate correct x coordinate
			let x;
			switch (style.label.textAlign) {
				case canvasEnums.textAlign.CENTER:
					x = panelLeft + panelWidth / 2;
					break;
				case canvasEnums.textAlign.LEFT:
					x = panelLeft + style.label.padding.left;
					break;
				case canvasEnums.textAlign.RIGHT:
					x = panelLeft + panelWidth - style.label.padding.right;
					break;
			}

			ctx.fillStyle = style.label.color;
			ctx.textAlign = style.label.textAlign;
			ctx.fillText(this.labelText, x, yMin + (yMax - yMin) / 2);
		}
	}

	/**
	 * The value of the band label
	 * If a translation key exists, translate dynamically on render (CH-2181)
	 * Otherwise use the legacy labelText param
	 */
	get labelText() {
		if (this.params.labelTranslationKey) {
			return translate(
				this.panel.core.locale,
				this.params.labelTranslationKey
			);
		} else {
			return this.params.labelText;
		}
	}
}

export default BandMarker;
